<ng-container *ngIf="!hasError; else mediaError">
    <plyr
        *ngIf="!(media.provider === 'html5' && media.mediaType === 'video')"
        style="display: block; width: 100%"
        plyrTitle="NK3 Player"
        [plyrPlaysInline]="true"
        [plyrType]="media.mediaType | cast"
        [plyrSources]="[{ src: media.src ?? media.url, type: media.type, provider: media.provider }]"
        [plyrOptions]="media.playerOptions"
        (plyrInit)="onInit($event)"
        (plyrReady)="onReady()"
        (plyrPlay)="played.emit(true)"
        (plyrError)="onError($event)"
        (plyrEnded)="mediaCompleted.emit(true)"
    >
    </plyr>
    <!-- https://videogular.github.io/ngx-videogular/docs/getting-started/using-the-api.html -->
    <!-- https://videogular.github.io/ngx-videogular/docs/modules/core/services/vg-api/ -->
    <vg-player
        (error)="onError($event)"
        *ngIf="media.provider === 'html5' && media.mediaType === 'video'"
        (onPlayerReady)="onPlayerReady($event)"
    >
        <vg-overlay-play *ngIf="!hideControls"></vg-overlay-play>
        <vg-buffering></vg-buffering>

        <vg-scrub-bar *ngIf="!hideControls">
            <vg-scrub-bar-current-time></vg-scrub-bar-current-time>
            <vg-scrub-bar-buffering-time></vg-scrub-bar-buffering-time>
        </vg-scrub-bar>

        <vg-controls *ngIf="!hideControls" [vgAutohide]="true" [vgAutohideTime]="1.5">
            <vg-play-pause></vg-play-pause>
            <vg-playback-button></vg-playback-button>

            <vg-scrub-bar style="pointer-events: none"></vg-scrub-bar>

            <vg-time-display vgProperty="current" vgFormat="mm:ss"></vg-time-display>

            <vg-time-display vgProperty="total" vgFormat="mm:ss"></vg-time-display>

            <vg-track-selector></vg-track-selector>

            <vg-mute></vg-mute>
            <vg-volume></vg-volume>

            <vg-fullscreen></vg-fullscreen>
        </vg-controls>

        <video
            [vgMedia]="$any(myMedia)"
            #myMedia
            id="singleVideo"
            [autoplay]="autoplay"
            [attr.playsinline]="autoplay ? '' : null"
            preload="auto"
            crossorigin
            (error)="onError($event)"
        >
            <source [src]="media.url || media.src" [type]="media.type" (error)="onError($event)" />
        </video>
    </vg-player>
</ng-container>

<!-- Friendly fallback shown when the media fails to load/play so the player never crashes. -->
<ng-template #mediaError>
    <div class="media-player-error" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="8px">
        <mat-icon class="media-player-error__icon">error_outline</mat-icon>
        <span class="media-player-error__text" i18n>This media couldn't be played right now.</span>
        <div class="media-player-error__actions" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="8px">
            <button
                mat-stroked-button
                color="primary"
                type="button"
                class="media-player-error__retry"
                (click)="retryLoad()"
            >
                <mat-icon>refresh</mat-icon>
                <span i18n>Try again</span>
            </button>
            <button
                *ngIf="hasRemoveVideoPlayerOption"
                mat-stroked-button
                color="warn"
                type="button"
                class="media-player-error__remove"
                (click)="onRemoveMedia()"
            >
                <mat-icon>delete_outline</mat-icon>
                <span i18n>Remove</span>
            </button>
        </div>
    </div>
</ng-template>
